import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  PAYMENT: {
    path: `${baseRoutes.userBaseRoutes}payment`,
  },
  COUPON: {
    path: `${baseRoutes.userBaseRoutes}coupon`,
  },
};

export default accessRoute;
